module.exports = __webpack_public_path__ + "img/aeilo.05b4bb66.jpg";